export default {
  auth: () => import("D:/win_www/powerflow/powerflow-site/layouts/auth.vue"),
  base: () => import("D:/win_www/powerflow/powerflow-site/layouts/base.vue"),
  chat: () => import("D:/win_www/powerflow/powerflow-site/layouts/chat.vue"),
  default: () => import("D:/win_www/powerflow/powerflow-site/layouts/default.vue")
}